import { useInfiniteQuery } from "react-query";
import axios from "infra/http";
import { CobrancaItem } from "../typings";
import { FiltroCobranca } from "core/features/cobranca/typings";
import { PaginateResult } from "core/resources/types/shared";

function useCobrancas(query: FiltroCobranca) {
  return useInfiniteQuery(
    [`/v1/cobranca`, query],
    async ({pageParam}) => {
      const res = await axios.get<PaginateResult<CobrancaItem>>(
        `/v1/cobranca`,
        {
          params: {...query, page: pageParam},
        }
      );

      return res.data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage >= lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}

export default useCobrancas;
